/* CAC M77 accessory guard: storefront experience only, not server-side checkout validation. */
(() => {
  const BOOTS = new Set([10781695639899, 10781680533851, 10781681254747]);
  const SOCKS = 10781680370011;
  let busy = false;
  let submitting = false; // evita envíos duplicados del checkout (doble clic)
  window.addEventListener('pageshow', () => { submitting = false; }); // volver atrás (bfcache) reactiva el botón
  const cartUrl = (p) => (window.Shopify?.routes?.root || '/').replace(/\/$/, '/') + p;
  async function cleanOrphans() {
    if (busy) return false;
    busy = true;
    try {
      const cartResp = await fetch(cartUrl('cart.js'), {credentials:'same-origin',cache:'no-store'});
      if (!cartResp.ok) return false;
      const cart = await cartResp.json();
      const hasBoots = cart.items.some(i => BOOTS.has(Number(i.product_id)));
      const m77Orphans = hasBoots ? [] : cart.items.filter(i => Number(i.product_id) === SOCKS);
      const candleSetIds = new Set([10790381125979,10790381355355,10790381289819,10790381388123,10790381322587,10790381420891,10785189855579,10778165477723,10778165543259,10778165510491,10778165576027,10777775079771,10777775374683,10777775243611,10777775505755]);
      const presentCandleSets = new Set(cart.items.map(i => Number(i.product_id)).filter(id => candleSetIds.has(id)));
      const refillProductIds = new Set([10790316015963,10790315983195,10790315950427]);
      const candleOrphans = cart.items.filter(item => {
        if (!refillProductIds.has(Number(item.product_id))) return false;
        const linkedParent = Number(item.properties?.['_CAC Candledust set'] || 0);
        return !candleSetIds.has(linkedParent) || !presentCandleSets.has(linkedParent);
      });
      const orphans = [...new Map([...m77Orphans, ...candleOrphans].map(item => [item.key, item])).values()];
      for (const item of orphans) {
        const resp = await fetch(cartUrl('cart/change.js'),{
          method:'POST', credentials:'same-origin',headers:{'Content-Type':'application/json'},
          body: JSON.stringify({id:item.key,quantity:0})
        });
        if (!resp.ok) throw new Error('No se pudo retirar el complemento');
      }
      return orphans.length>0;
    } catch (e) { console.warn('[CAC M77] Cart validation error',e); return false; }
    finally { busy=false; }
  }
  async function verifyAndRefresh() {
    const changed=await cleanOrphans();
    if (changed && (location.pathname.endsWith('/cart') || document.querySelector('cart-drawer-component'))) {
      location.reload();
    }
  }
  document.addEventListener('DOMContentLoaded',verifyAndRefresh);
  document.addEventListener('click', async (event) => {
    const target=event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], a[href*="/cart/checkout"]');
    if (!target || !document.querySelector('body')) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (submitting) return;
    submitting = true;
    setTimeout(() => { submitting = false; }, 5000); // por si la navegación no llega a producirse
    const changed=await cleanOrphans();
    if (changed) {location.assign(cartUrl('cart'));return;}
    if (target.tagName==='A') location.assign(target.href);
    else if (target.form) {
      // 14-10-2026: form.submit() no envía el botón pulsado, así que Shopify no recibía «checkout» y volvía a /cart.
      // requestSubmit(target) envía el formulario como si se hubiera pulsado ese botón (incluye name="checkout").
      if (typeof target.form.requestSubmit === 'function') target.form.requestSubmit(target);
      else {
        const field = document.createElement('input');
        field.type = 'hidden'; field.name = target.name || 'checkout'; field.value = target.value || '';
        target.form.appendChild(field); target.form.submit();
      }
    }
    else location.assign('/checkout');
  },true);
  document.addEventListener('click',event => {
    if (event.target.closest('[data-cart-remove], [aria-label*="Eliminar"], button[name="minus"], cart-items-component')) {
      setTimeout(verifyAndRefresh,900);
    }
  });
  document.addEventListener('cart:updated',verifyAndRefresh);
  document.addEventListener('cart:refresh',verifyAndRefresh);
})();

/* 14-10-2026 · CAC: desbloqueo del scroll al cerrar el cajón con «atrás» de Android.
   Android (y Esc en algunos casos) cierra el <dialog> del cajón de forma nativa; el tema no se entera y deja
   html[scroll-lock], así que la página no se puede desplazar. Si eso pasa, se llama al cierre normal del tema. */
(() => {
  document.addEventListener('close', (event) => {
    const dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    const drawer = dialog.closest('theme-drawer');
    if (!drawer || drawer.__cacClosing || typeof drawer.close !== 'function') return;
    setTimeout(() => {
      if (!document.documentElement.hasAttribute('scroll-lock') || document.querySelector('dialog[open]')) return;
      drawer.__cacClosing = true;
      try { drawer.close(); } finally { setTimeout(() => { drawer.__cacClosing = false; }, 0); }
    }, 0);
  }, true);
})();
